import { __ } from "@wordpress/i18n";
import React, { useState } from 'react';
import Hint from '../components/Hint/Hint';
import { useMenu } from '../contexts/MenuContext';
import { formDataPost } from '../helpers/Helpers';
import withForm from '../layouts/withForm';
const LoginActionLoginAutomations = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [role, setRole] = useState('')
    const [status, seStatus] = useState('')
    const [date, setDate] = useState('')

    const userRoleList = ultimate_security_ajax_obj?.userRoleList || [];
    const [processing, setProcessing] = useState(false)
    const [processingRing, setProcessingRing] = useState(false)
    const [processingTick, setProcessingTick] = useState(false)
    const handleAction = async () => {
        setProcessing(true);
        setProcessingRing(true);
        try {
            const result = await formDataPost(
                "ultimate_security_automations_delete_users", 
                {
                    'role':role, 
                    'session':status, 
                    'date': date
                }
            );
            // console.log('result: ',result) 
            if (result.success) {
                setProcessingRing(false);
                setProcessingTick(true)
                setRole('')
                seStatus('')
                setDate('')
                
                setTimeout(()=> {
                    setProcessingTick(false)
                    setProcessing(false)
                },1000)
            }
                
            // setReload(prev => !prev); // Trigger reload to force re-render
        } catch (error) {
            // console.log(error.message);
        } finally {
            setProcessing(false);
            setProcessingRing(false)
        } 
    }

    return (
        <>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Select Input", "ultimate-security")}</h5>
                            {/* <p className="pl-body text-text">{__("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deserunt, cum.", "ultimate-security")}</p> */}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("User Role:", "ultimate-security")}</h6>
                                </div>
                                <div className="content-below-with-hint mt-2">
                                    <select 
                                        className="form-select"
                                        value={role} 
                                        onChange={(e) => setRole(e.target.value)}
                                    >
                                        <option value="">{__("Select Role", "ultimate-security")}</option>
                                        {
                                            userRoleList.length && userRoleList.map(item=> (   
                                                <option 
                                                    value={item.code}
                                                    key={item.code} 
                                                >
                                                    {item.value}
                                                </option>                                     
                                            ))  
                                        }
                                    </select>

                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-between mt-2">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Sessions Type", "ultimate-security")}</h6>
                                </div>
                                <div className="content-below-with-hint mt-2">
                                    <select 
                                        className="form-select"
                                        value={status} 
                                        onChange={(e) => seStatus( e.target.value)}
                                    >
                                        <option value="">{__("Select Option", "ultimate-security")}</option>
                                        <option value="has-session">{__("Has active sessions", "ultimate-security")}</option>
                                        <option value="no-session">{__("No active sessions", "ultimate-security")}</option>
                                    </select>

                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-between mt-2">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Sessions Date", "ultimate-security")}</h6>
                                </div>
                                <div className="content-below-with-hint mt-2">
                                    <input 
                                        className="form-control"
                                        type="date"
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">
                                    <div className="d-flex align-items-center gap-2">                                    
                                        <button 
                                            type="button" 
                                            className="button button-link" 
                                            onClick={handleAction}
                                            disabled={processing}
                                        >
                                            {
                                                processing ? __( "Processing...", "ultimate-security" ) : __( "Start Deletion", "ultimate-security" )
                                            }
                                        </button>
                                        {processingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                        {processingTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(LoginActionLoginAutomations);